import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import StickyHeader from '../../views/app/StickyHeader';
import Footer from '../Footer';
import Loading from '../loading/loading';
import css from './full-page-loader.module.scss';

export function FullPageLoader() {
  return (
    <Fragment>
      <Helmet>
        <title>Altibox TV</title>
      </Helmet>

      <StickyHeader />
      <Loading classNames={{ container: css.loader }} size={64} contained />
      <Footer />
    </Fragment>
  );
}
